import { render } from "./PromemoriaForm.vue?vue&type=template&id=4ab7997b"
import script from "./PromemoriaForm.vue?vue&type=script&lang=js"
export * from "./PromemoriaForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__